import { Box, Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LoginPage } from "../../components/LoginRegistration/LoginPage";
import { RegistrationPage } from "../../components/LoginRegistration/RegistrationPage";

export const LoginRegistration = () => {
  const [loginRegPage, setLoginRegPage] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      const islogin = sessionStorage.getItem("isLogin") ? true : false;
      const opkey_id = sessionStorage.getItem("opkey");
      if (islogin && opkey_id) {
        window.location.href = "/dashboard";
      } else {
        sessionStorage.removeItem("isLogin");
      }
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Grid container component="main" sx={{ height: "100vh", overflow: "hidden" }}>
      <Grid item xs={12} sm={12} md={6} component={Paper} elevation={0} square>
        <Box
          sx={{
            my: 3,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            height: "100vh",
          }}
        >
          {!loginRegPage ? (
            <LoginPage setLoginRegPage={setLoginRegPage} />
          ) : (
            <RegistrationPage setLoginRegPage={setLoginRegPage} />
          )}
        </Box>
      </Grid>

      <Grid item md={6}>
        <img
          src={require("../../assets/PNGBackground.png")}
          alt="Login Background"
          style={{ width: "90%", height: "100%", objectFit: "scale-down", overflow: "hidden" }}
        />
      </Grid>
    </Grid>
  );
};
